//TODO, keep campaign maps up to date.


import { Component } from '@angular/core';
import { HeaderComponent } from './components/header/header';
import { FooterComponent } from './components/footer/footer';
import { CampaignsComponent } from './components/campaigns/campaigns';
import { AuthenticationService } from "./_services/authentication.service";
import { AlertService } from "./_services/alert.service";
import { CRMStats, DownloadResult } from "./_models/crmStats";
import { InvoicingComponent } from "./components/invoicing/invoicing";
import { CustomersComponent } from "./components/customers/customers";
import { SettingsService } from "./_services/settings.service";
import { ReportsComponent } from "./components/reports/reports";
import { ReportsService } from "./_services/reports.service";
import { ItemsComponent } from "./components/items/items";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    providers: [HeaderComponent, FooterComponent,CampaignsComponent,InvoicingComponent,CustomersComponent,ReportsComponent,ItemsComponent]
})
export class AppComponent {

  page = 0;
  name = 'Start';
  now: Date = new Date();
  settingContent = 1;
  pageSettings = this.set.pageSettings;
  invoiceSettings = this.set.invoiceSettings;
  
  reportId = 0;
  pauseECRM = false;
  pauseICRM = false;
  overrideStart = new Date();
  overrideEnd = new Date(2017, 9, 1);
  
   
    startTime = new Date();
    totalRuns = 0;
    inzuzoResult: DownloadResult[] = [];
    enquiryResult: DownloadResult[] = [];

    ioTokenPresent = false;
    ioDays = 1;
    minMatch: Date = new Date();

    constructor(public auth: AuthenticationService,
      private alert: AlertService, public set: SettingsService, public rep:ReportsService) {
      let token = localStorage.getItem("ioToken");
      if (token) this.ioTokenPresent = true;
    }

    
    startup(logsuccess:boolean) {
      if (logsuccess) {
        this.getStats();
        if (this.auth.isTFAS) this.pageSettings.currentPage = 4;
      }
    }
    setStart(d) {
      this.overrideStart = new Date(d);
    }
    setEnd(d) {
      this.overrideEnd = new Date(d);
    }
    getStats() {
      this.auth.getProgress().subscribe((data: CRMStats) => {
        this.auth.stats = new CRMStats(data);
        if (this.auth.stats.LastInzuzoRun.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
          //this.startBack(true);
        }
      });
    }
    startBack(inzuzo:boolean,date?:Date) {
      if ((this.pauseICRM && inzuzo) || (this.pauseECRM && !inzuzo)) {
        this.pageSettings.running = false;
        setTimeout(() => {
          this.startBack(inzuzo, date)
        }, 6000);
      }
      else {
        this.pageSettings.running = true;
        if (!date) date = this.overrideStart;
        if ((inzuzo && date > this.overrideEnd) || (!inzuzo && date > this.overrideEnd)) {
          this.auth.startLoad(inzuzo, date).subscribe((data) => {
            this.totalRuns++;
            if (inzuzo) this.inzuzoResult.unshift(data);
            else this.enquiryResult.unshift(data);
            this.startBack(inzuzo, new Date(data.CurrentDate));
          }, error => {
            this.alert.error(error);
          });
        }
        else {
          this.auth.recordRun(inzuzo);
          this.pageSettings.running = false;
          if (inzuzo && this.auth.stats.LastEnquiryRun.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            this.startBack(false);
          }
          else {
            this.getStats();
          }
        }
      }
    }
    checkAnalytics() {
      this.auth.analytics().subscribe((data) => {
        alert("done");
      }, error => {
        this.alert.error(error);
      });
    }
    updateInv() {
      this.set.updateInv().subscribe((data) => {
        this.set.getSettings().subscribe((res) => {
          this.set.settings = res;
          this.set.setInvoiceSettings();
        })
      });
    }
    updateRepSetting(which) {
      if (which == 8) {
        let val = this.set.reportSettings.transferValue ? "1" : "0";
        this.set.updateRepSetting(which, val);
      }
      else this.set.updateRepSetting(which, this.set.reportSettings.crossCampaign.toString());
    }


    getIOToken() {
      this.auth.ioToken().subscribe((res: any) => {
        res.granted = new Date();
        localStorage.setItem("ioToken",res );
      })
    }
    ioRefresh() {
      let token = this.handleToken();
      if (token) {
        this.auth.ioRefresh(token).subscribe((res: any) => {
          if (res.access_token && res.access_token != "") {
            localStorage.setItem("ioToken", JSON.stringify(res));
            this.getAdvisers();
          }
        })
      }
    }
    fakeToken() {
      var token = { access_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Impvb25tcFBvaUtmMm9LMkdfVUdhOGJ3dEk1cyIsImtpZCI6Impvb25tcFBvaUtmMm9LMkdfVUdhOGJ3dEk1cyJ9.eyJpc3MiOiJodHRwczovL2lkc3J2My5jb20iLCJhdWQiOiJodHRwczovL2lkc3J2My5jb20vcmVzb3VyY2VzIiwiZXhwIjoxNTM0NDYwMDYyLCJuYmYiOjE1MzQ0NTY0NjIsImNsaWVudF9pZCI6ImFwcC0zYjAzYTlkLWFjZi03Yjk0NzdjNmIzOTg0ODVlOWM5ZTRkYjFlZDhkNGEyMyIsInNjb3BlIjpbIm9wZW5pZCIsIm15cHJvZmlsZSIsInByb2ZpbGUiLCJjbGllbnRfZGF0YSIsImNsaWVudF9maW5hbmNpYWxfZGF0YSIsImZpcm1fZGF0YSIsIm9mZmxpbmVfYWNjZXNzIl0sInN1YiI6ImIxN2M1NGQ4LWU2ZjctNDc4Yi05YTM5LWE5MjAwMGI1OGJhNyIsImF1dGhfdGltZSI6MTUzNDQ1NjQ1OSwiaWRwIjoiaWRzcnYiLCJlbWFpbCI6InJpY2hAaWRlYWZvdW5kcnkudWsiLCJmYW1pbHlfbmFtZSI6IkhpbGR5YXJkIiwiZ2l2ZW5fbmFtZSI6IlJpY2hhcmQiLCJncm91cF9pZCI6IjgwMTIiLCJncm91cF9saW5lYWdlIjoiODAxMiIsInBhcnR5X2lkIjoiMjQwNzk5ODMiLCJwZnBfZG9tYWluIjoidGZhcy5teXBmcC5jby51ayIsInBmcF9wcmVtaXVtIjoiRmFsc2UiLCJ0ZW5hbnRfZ3VpZCI6IjNhNWM1ZmFhLWFjZDktNGY2Zi1iNTUyLWVmN2I4OTU5OTViNCIsInRlbmFudF9pZCI6IjExNzYwIiwidXNlcl9pZCI6IjE2Mzg4NyIsInVzZXJuYW1lIjoiUkhpbDExNzYwIiwibmFtZSI6IlJIaWwxMTc2MCIsInBnaSI6IjgwMTIiLCJyb2xlX2lkIjoiMjcwNTYiLCJyb2xlX2lkcyI6IjI3MDU2Iiwicm9sZXMiOiJBZG1pbmlzdHJhdG9yIiwiaWRlbnRpdHlTZXJ2ZXJVcmkiOiJodHRwczovL2lkZW50aXR5LmludGVsbGlmbG8uY29tIiwiYW1yIjpbInBhc3N3b3JkIl19.XqPheAf9VC1N_tCf9uU8DUYcIxcyoPYdl81CmTeX8bIDsqiGe0zbT7dagJTKaGA3CunZeDCz-A5bQem4jIB77eTYDoDyLoD6K4cwB5BcZnN-ye4aiF8NXJibIXaCjWLvrkN-zEHZw4Lr9We41Um0ZQE3FMfr0FXPXq9f048h5QdFcCY06Pe5l8FU9y5vIPxhRUVidG3deXBenESID0SwMKUq08r2yAgQJzjnVZJ5I2K-qrXGFbz7_JrlPgW8vvdG0R6rsgjEEctGa_RKNxTWl5GHe6maHrQdEoJgRiMCBmIA0P83QFwsCPXaXUmqKiPV8XGEYg1bYv-N7qpUU_VlXw", token_type: "Bearer", refresh_token: "c007cb5301c6815dbd4f2ab363583f2b", expires_in: 3600, id_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Impvb25tcFBvaUtmMm9LMkdfVUdhOGJ3dEk1cyIsImtpZCI6Impvb25tcFBvaUtmMm9LMkdfVUdhOGJ3dEk1cyJ9.eyJpc3MiOiJodHRwczovL2lkc3J2My5jb20iLCJhdWQiOiJhcHAtM2IwM2E5ZC1hY2YtN2I5NDc3YzZiMzk4NDg1ZTljOWU0ZGIxZWQ4ZDRhMjMiLCJleHAiOjE1MzQ0NTY3NjIsIm5iZiI6MTUzNDQ1NjQ2MiwiaWF0IjoxNTM0NDU2NDYyLCJzaWQiOiI3NjViMjIwNjMyNDM4NWQxNDg1NTM4MTc4OTQ1NzBkMCIsInN1YiI6ImIxN2M1NGQ4LWU2ZjctNDc4Yi05YTM5LWE5MjAwMGI1OGJhNyIsImF1dGhfdGltZSI6MTUzNDQ1NjQ1OSwiaWRwIjoiaWRzcnYiLCJuYW1lIjoiUmljaGFyZCBIaWxkeWFyZCIsImVtYWlsIjoicmljaEBpZGVhZm91bmRyeS51ayIsImZhbWlseV9uYW1lIjoiSGlsZHlhcmQiLCJnaXZlbl9uYW1lIjoiUmljaGFyZCIsImdyb3VwX2lkIjoiODAxMiIsImdyb3VwX2xpbmVhZ2UiOiI4MDEyIiwicGFydHlfaWQiOiIyNDA3OTk4MyIsInBmcF9kb21haW4iOiJ0ZmFzLm15cGZwLmNvLnVrIiwicGZwX3ByZW1pdW0iOiJGYWxzZSIsInBnaSI6IjgwMTIiLCJyb2xlX2lkIjoiMjcwNTYiLCJyb2xlX2lkcyI6IjI3MDU2Iiwicm9sZXMiOiJBZG1pbmlzdHJhdG9yIiwidGVuYW50X2d1aWQiOiIzYTVjNWZhYS1hY2Q5LTRmNmYtYjU1Mi1lZjdiODk1OTk1YjQiLCJ0ZW5hbnRfaWQiOiIxMTc2MCIsInVzZXJfaWQiOiIxNjM4ODciLCJ1c2VybmFtZSI6IlJIaWwxMTc2MCIsImlkZW50aXR5U2VydmVyVXJpIjoiaHR0cHM6Ly9pZGVudGl0eS5pbnRlbGxpZmxvLmNvbSIsImFtciI6WyJwYXNzd29yZCJdfQ.URwTGi7lmL5aOba6JlPz_bMEsGDyfuPkAKAOdnw_fy9RSkBLvUkidIs0mrr00l17rwDX26uxU0sd2aidIkgA16XlAJdgOK7KGunsydvYaSth4FGB4ST-MfwYtI6uzZUvRriTWiBfsvA47ZHD9LbPMOafbxr7RXsRQQsHXtGAkaRXIKnhPqBcUPMtrvMj2I6y9_dbWIeknSFcx8LymxnfrU8RyNBN7bGmZqNH2McMYBkFKRBpuwbNbSir0jf66u2-5Yk974S3JiaSpQBmj2X09sFUZ4Oi_vuvci5x5xuFLCc-QD1P_ZASqJRUloKrxuDGtH0HOVHtJl2b02SGoraB7A",granted:new Date() };
      localStorage.setItem("ioToken", JSON.stringify(token));
    }
    advisers: any[] = [];

    getAdvisers() {
      this.pageSettings.running = true;
      let token = this.handleToken();
      if (token) {
        this.advisers = [];
        this.rep.getAdvisers(token).subscribe((res: any) => {
          if (res.items) {
            res.items.forEach((item) => {
              const adviser = { name: item.name, id: item.id };
              this.advisers.push(adviser);
            });
            this.getMatches();
          }
          else {
            this.alert.error("IO Login expired, attempting to refresh token");
            this.ioRefresh();
          }
        }, (err: any) => {
          console.log(err);
          this.alert.error("IO Login expired, attempting to refresh token");
          this.ioRefresh();
        });
      }
      else {
        this.pageSettings.running = false;
        this.alert.error("Please login to IO");
      }
    }
    matches: any = [];
    getMatches() {
      const token = localStorage.getItem("ioToken");
      if (token) {

        this.rep.getMatches(JSON.parse(token),this.ioDays).subscribe((res: any) => {
          this.matches = [];
          res.forEach(match => {
            const crm = { name: match.CRM.FullName, lastNote: match.CRM.LastNote, type: match.CRM.LeadType, address: match.CRM.Address, postcode: match.CRM.Postcode, ref: match.CRM.Id, date: match.CRM.TransferDateTime, value: match.CRM.Value, adviser: 0, isInzuzo:match.CRM.CRMLogin=='Inzuzo' };
            this.matches.push(crm);
            if (new Date(match.CRM.TransferDateTime) < this.minMatch) {
              this.minMatch = new Date(match.CRM.TransferDateTime);
            }
          });
          this.pageSettings.running = false;
        })
      }
      else {
        this.alert.error("Please login to IO");
      }
    }
    selectAdviser(id, match) {
      match.adviser = id;
    }
    handleToken() {
      let token = localStorage.getItem("ioToken");
      if (token && token!="null") {
        return JSON.parse(token);
      }
      else {
        this.auth.ioToken().subscribe((res: any) => {
          if (!res) {
            return null;
          }
          else {
            token = JSON.stringify(res);
            localStorage.setItem("ioToken", token);
            return res;
          }
          
        })
      }
    }
    upload(match:any) {
      let t = localStorage.getItem("ioToken");
      const token = JSON.parse(t);
      let advname = "";
      this.advisers.some((adv: any) => {
        if (adv.id == match.adviser) {
          match.adviserName = adv.name;
          return true;
        }
      })
      this.rep.uploadLead(match, token).subscribe((res: any) => {
        if (res.Successful) {
          let index = 0;
          let found = false;
          this.matches.some(ematch => {
            if (ematch.ref == match.ref) {
              found = true;
              return true;
            }
            index++;
          })
          if (found) {
            this.matches.splice(index, 1);
          }
          this.alert.success("Upload Successful");
        }
        else if (res.PartialSuccess) {
          let messages = "";
          res.Messages.forEach(msg => {
            messages += msg;
          });
          let index = 0;
          let found = false;
          this.matches.some(ematch => {
            if (ematch.ref == match.ref) {
              found = true;
              return true;
            }
            index++;
          })
          if (found) {
            this.matches.splice(index, 1);
          }
          this.alert.success("Upload partially successful: " + messages);
        }
        else {
          let messages = "";
          res.Messages.forEach(msg => {
            messages += msg;
          });
          this.alert.error("Upload Failed.")
        }
      });
    }
    fake() {
      let t = localStorage.getItem("ioToken");
      const token = JSON.parse(t);
      this.auth.fake(token).subscribe((res: Response) => {
        console.log(res);
      });
    }
    clearToken() {
      localStorage.removeItem("ioToken");
    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/app.component.ts